var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.967 20.608a.559.559 0 0 1-.08.137.499.499 0 0 1-.387.184H6.313a.5.5 0 0 1-.473-.337l-2.813-8.143a.5.5 0 0 1 .473-.663h15.187a.5.5 0 0 1 .473.336L21 17.45V5.5h-5.282l-1.795 2.035a.5.5 0 0 1-.375.17H7v3.289a.5.5 0 1 1-1 0v-3.79a.5.5 0 0 1 .5-.5h6.823l1.795-2.035a.5.5 0 0 1 .375-.169H21.5a.5.5 0 0 1 .5.5v15.41a.494.494 0 0 1-.033.198zm-15.298-.68H20.8l-2.468-7.142H4.2l2.468 7.143z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.bd3a13c19f14b3357b8c5fc936ce720b.svg";
export { ForwardRef as ReactComponent };